import en from '../../locale/en.json';
import cs from '../../locale/cs.json';
import da from '../../locale/da.json';
import de from '../../locale/de.json';
import es from '../../locale/es.json';
import fr from '../../locale/fr.json';
import hu from '../../locale/hu.json';
import id from '../../locale/id.json';
import it from '../../locale/it.json';
import nb from '../../locale/nb.json';
import nl from '../../locale/nl.json';
import pl from '../../locale/pl.json';
import ptbr from '../../locale/pt-br.json';
import ru from '../../locale/ru.json';
import sk from '../../locale/sk.json';
import sv from '../../locale/sv.json';
import fi from '../../locale/fi.json';

export default {
  en,
  cs,
  da,
  de,
  es,
  fr,
  hu,
  id,
  it,
  nb,
  nl,
  pl,
  'pt-br': ptbr,
  ru,
  sk,
  sv,
  fi,
};
